import { render, staticRenderFns } from "./CorosConnector.vue?vue&type=template&id=40268f5a&scoped=true"
import script from "./CorosConnector.vue?vue&type=script&lang=js"
export * from "./CorosConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40268f5a",
  null
  
)

export default component.exports